
import { GrLinkNext } from "react-icons/gr";
import { GrLinkPrevious } from "react-icons/gr";


function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
                opacity: 1,
                width: '68px',
                height: '68px',
                borderRadius: '50%',
                color: '#fff',
                backgroundColor: '#28A745',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            onClick={onClick}
        >
            <GrLinkNext  size={36} color="#fff" />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
        className={className}
        style={{
            ...style,
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
            opacity: 1,
            width: '68px',
            height: '68px',
            borderRadius: '50%',
            color: '#fff',
            backgroundColor: '#28A745',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
        onClick={onClick}
    >
        <GrLinkPrevious  size={36} color="#fff" />
    </div>
    );
}


export const slideSlick = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    fade: true,
    easing: "fade",
    adaptiveHeight: true
};

export const slideCustom = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};